<template>
    <div class="content-container">
        <div class="article-bodyhtml" v-html="content"></div>
    </div>
</template>

<script>
export default {
    props: ['content'],
}
</script>

<style lang="scss" scoped>
.content-container {
    padding: 15px;
    max-width: 1240px;
    width: 100%;
    margin: 0 auto;
}

@media (min-width: 798px) {
    .content-container {
        padding-top: 30px;
        padding-bottom: 30px;
    }
}

@media (min-width: 1240px) {
    .content-container {
        padding-top: 92px;
        padding-bottom: 92px;
    }
}
</style>